import { getStyleStringFromObject } from 'helpers/getStyleStringFromObject';
import React, { useRef, useEffect } from 'react';

export const ReportTableCustomTableHeader = ({ style, attribute, styleString, children }) => {
    const thRef = useRef<HTMLTableCellElement>(null);

    useEffect(() => {
        if (thRef.current && (styleString || style)) {
            const concatStyle = (getStyleStringFromObject(style) ? getStyleStringFromObject(style) + ';' : '') + styleString;
            // console.log(concatStyle);
            thRef.current.setAttribute('style', concatStyle);
        }

        if (thRef.current && attribute) {
            attribute.forEach((attr) => {
                thRef.current?.setAttribute(attr.key, attr.value);
            });
        }
    }, [styleString]);

    return <th ref={thRef}>{children}</th>;
};